/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import * as React from 'react';

import { css, jsx } from '@atlaskit/css';
import StarIcon from '@atlaskit/icon/glyph/star';
import StarFilledIcon from '@atlaskit/icon/glyph/star-filled';
import { token } from '@atlaskit/tokens';

interface StarProps {
    label: string;
    className?: string;
    filled?: boolean;
}

export class Star extends React.Component<StarProps> {
    getIcon(label: string, filled: boolean) {
        if (filled) {
            return <StarFilledIcon label={label} size="large" />;
        }
        return <StarIcon label={label} size="large" />;
    }

    render() {
        const { filled, label } = this.props;

        const starIcon = this.getIcon(label, !!filled);

        return <span css={starContainerStyles}>{starIcon}</span>;
    }
}

export const EmptyStar: React.FunctionComponent<StarProps> = ({ label }) => <Star label={label} />;
export const FullStar: React.FunctionComponent<StarProps> = ({ label }) => <Star label={label} filled />;

const starContainerStyles = css({
    color: token('color.text.brand', '#0C66E4'),
    padding: token('space.050', '4px'),
});
